import { Component } from "react";
import type { ReactNode, ErrorInfo } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
  isChunkError: boolean;
}

export class ChatErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, isChunkError: false };

  static getDerivedStateFromError(error: Error): State {
    const isChunk =
      error.message.includes("dynamically imported module") ||
      error.message.includes("Failed to fetch");
    return { hasError: true, isChunkError: isChunk };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ChatErrorBoundary]", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center gap-4 p-8 text-center">
          <p className="text-sm text-muted-foreground">
            {this.state.isChunkError
              ? "Uma nova versao esta disponivel."
              : "Algo deu errado no chat."}
          </p>
          <Button size="sm" onClick={() => window.location.reload()}>
            <RefreshCw className="mr-2 h-4 w-4" />
            Atualizar pagina
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
